export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/filter.worker.a6c80491.worker.js");
}
